<!--
    @file:用于展示单个车辆的实时定位和实时数据 父模块为 车辆定位 / 车辆追踪模块
    @props:{Object} poits 单个点的位置和车辆的其他信息
-->
<template>
    <div id="amap-marker" class="amap">
    </div>
</template>

<script>
import AMap from 'AMap';
import AMapUI from 'AMapUI';
export default {
    name: 'amap-marker',
    created () {
        /**
         * nextTick 在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM。
         * getAmapApi 加载异步组件 AMap
         * 初始化地图
         */
        this.$nextTick(function () {
            var self = this;
            self.getAmapApi().then(AMap => {
                self.map = new AMap.Map('amap-marker', {
                    zoom: 12,
                    center: [116.480983, 40.0958]
                });
                AMapUI.loadUI(['overlay/SimpleMarker', 'overlay/SimpleInfoWindow'], function (SimpleMarker, SimpleInfoWindow) {
                    // 创建SimpleMarker实例
                    self.marker = new SimpleMarker({
                        iconStyle: {
                            src: './static/img/car_run.png',
                            width: 30,
                            height: 44,
                            offset: ['-50%', '-80%']
                        },
                        map: self.map
                    });
                    self.initInfo(SimpleInfoWindow);
                    AMap.event.addListener(self.marker, 'click', function () {
                        if (self.showInfo) {
                            self.closeInfoWin();
                        } else {
                            self.openInfoWin();
                        }
                    });
                });
            });
        });
    },
    data () {
        return {
            map: {}, // 地图实例
            marker: {}, // marker实例
            infoWindow: {}, // infoWindow 实例
            mapData: false, // 用来记录数据变动,触发地图重新绘制
            markerSim: false, // 用来记录地图是否已经初始化
            myData: [], // 数据实例记录
            statusList: ['alarm', 'run', 'stop'], // 三种汽车的状态数组
            showInfo: false, // 记录点击marker实例信息窗体是否打开
            status: 1 // 记录当前的汽车的状态,判断是否需要修改infoWindow实例和marker实例的样式
        };
    },
    props: ['poits'],
    methods: {
        getAmapApi () {
            /**
             * 异步加载地图控件
             *
             */
            return new Promise(function (resolve, reject) {
                resolve(AMap);
            });
        },
        openInfoWin () {
            /**
             * 打开信息窗体
             *
             */
            this.infoWindow.open(this.map, this.marker.getPosition());
            this.showInfo = true;
        },
        closeInfoWin () {
            /**
             * 关闭信息窗体
             *
             */
            this.infoWindow.close();
            this.showInfo = false;
        },
        initInfo (SimpleInfoWindow) {
            /**
             * 初始化信息窗体 模板数据
             *
             */
            var tpl = '' +
            '<div class="maker-info <% if(run_status===0) { %> alarm <% }else if(run_status ===1){%> run <% }else{%>stop<%}%> ">' +
            '    <p class="title">车辆当前信息</p>' +
            '    <p class="info">' +
            '        时间: <%= time %>' +
            '        <br />电池编码: <%= battery_code %>' +
            '        <br />电池状态: <%= battery_status %>' +
            '        <br />SOC: <%= soc %>' +
            '        <br />车牌号码: <%= plate_number %>' +
            '        <br />厂家车辆编号: <%= production_vehicle_no %>' +
            '        <br />系统运行状态: <%= system_run_status %>' +
            '        <br />速度: <%= velocity %>' +
            '        <br />方位: <%= direction %>' +
            '        <br />地址: <%= gps %>' +
            '    </p>' +
            '    <div class="maker-loading <% if(battery_code) { %> hide <% } %>">' +
            '       <div class="el-loading-spinner">' +
            '         <svg viewBox="25 25 50 50" class="circular">' +
            '               <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>' +
            '         </svg>' +
            '       </div>' +
            '    </div>' +
            '</div>';
            this.infoWindow = new SimpleInfoWindow({
                infoTitle: '',
                infoBody: tpl,
                offset: new AMap.Pixel(0, -38)
            });
            this.openInfoWin();
            this.markerSim = true;
        }
    },
    computed: {
        initData: function () {
            /**
             * 判断地图API加载完毕且父模板有数据
             *
             */
            return this.markerSim && this.mapData;
        }
    },
    watch: {
        poits: {
            handler: function (val, oldVal) {
                this.myData = val;
                this.mapData = !this.mapData;
            },
            deep: true
        },
        initData: function () {
            /**
             * 更新点Marker位置和图标,更新信息窗体的数据
             *
             */
            var position = new AMap.LngLat(this.myData.gps[0], this.myData.gps[1]);
            this.marker.setPosition(position);
            this.infoWindow.setPosition(position);
            this.map.setCenter(position);
            this.infoWindow.setInfoTplData(this.myData);
            if (this.status !== this.myData.run_status) {
                this.status = this.myData.run_status;
                var iconStyle = {
                    src: './static/img/car_' + this.statusList[this.status] + '.png',
                    width: 30,
                    height: 44,
                    offset: ['-50%', '-80%']
                };
                this.marker.setIconStyle(iconStyle);
            }
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./map-style.css"></style>



// WEBPACK FOOTER //
// amap-marker.vue?430ada96